// extracted by mini-css-extract-plugin
module.exports = {"bigblue":"mystyle_bigblue__2LzK_","label":"mystyle_label__3hfgv","center":"mystyle_center__VGHk0"};